export default class Widget {
  constructor (configuration) {
    this.configuration = configuration
    if (new.target === Widget) {
      throw new TypeError('Cannot construct Abstract Widget instances directly')
    }
  }

  static name
  static widget
  static configure

  get data () {
    return new Promise((resolve) => {
      resolve()
    })
  }
  get props () {
    return Object.assign({}, this.configuration)
  }
}
